import React from 'react'
import PortalCreateModal from './PortalCreateModal'
import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import { compose } from 'recompose'

class PortalCreateModalWithRedux extends React.Component {
  static propTypes = {
    ...modalPropTypes,
  }

  handleClose = (value) => {
    this.props.modalActions.hideModal({portalID: value.portalID})
  }

  render() {
    return <PortalCreateModal onRequestClose={this.handleClose} />
  }
}

export default compose(withReduxModal)(PortalCreateModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/portal-create/PortalCreateModalWithRedux.js